import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Row, Col, Alert, InputGroup, Table, Badge } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { FaTrash, FaPlus, FaSearch, FaShieldAlt, FaCopy, FaExclamationTriangle, FaUsers, FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import * as api from '~/Services/Service';
import AuthStorage from '~/Utils/AuthStorage';
import { caracteristicas } from '~/constant';
import { customStyles } from '~/Styles/reactSelectStyles';

var opcoesFiltro = [
  { value: 'todos', label: 'Todos' },
  { value: 'descricao', label: 'Descrição' },
  { value: 'texto', label: 'Texto' },
  { value: 'menu', label: 'Menu' },
];

var SectionCard = function (props) {
  var className = 'usu-form-section';
  if (props.variant) className += ' usu-form-section--' + props.variant;

  return (
    <div className={className}>
      <div className="usu-form-section__header">
        <h6 className="usu-form-section__title">
          {props.icon && <span className="icon">{props.icon}</span>}
          {props.title}
        </h6>
        {props.headerRight}
      </div>
      <div className="usu-form-section__body">
        {props.children}
      </div>
    </div>
  );
};

var TabPermissoes = function (props) {
  var codigoUsuario = props.codigoUsuario;
  var isNovoMode = props.isNovoMode;
  var codigoGrupo = props.codigoGrupo;
  var nomeGrupo = props.nomeGrupo;

  var _useState = function (val) { return useState(val); };

  var permissoesState = _useState([]);
  var permissoes = permissoesState[0]; var setPermissoes = permissoesState[1];
  var loadingState = _useState(false);
  var loading = loadingState[0]; var setLoading = loadingState[1];
  var loadingAcaoState = _useState(false);
  var loadingAcao = loadingAcaoState[0]; var setLoadingAcao = loadingAcaoState[1];

  var showAdicionarModalState = _useState(false);
  var showAdicionarModal = showAdicionarModalState[0]; var setShowAdicionarModal = showAdicionarModalState[1];
  var termoBuscaState = _useState('');
  var termoBusca = termoBuscaState[0]; var setTermoBusca = termoBuscaState[1];
  var filtroCaractState = _useState('todos');
  var filtroCaract = filtroCaractState[0]; var setFiltroCaract = filtroCaractState[1];
  var catalogoState = _useState([]);
  var catalogo = catalogoState[0]; var setCatalogo = catalogoState[1];
  var loadingBuscaState = _useState(false);
  var loadingBusca = loadingBuscaState[0]; var setLoadingBusca = loadingBuscaState[1];

  var showCopiarModalState = _useState(false);
  var showCopiarModal = showCopiarModalState[0]; var setShowCopiarModal = showCopiarModalState[1];
  var usuarioFonteState = _useState(null);
  var usuarioFonte = usuarioFonteState[0]; var setUsuarioFonte = usuarioFonteState[1];
  var usuariosOptionsState = _useState([]);
  var usuariosOptions = usuariosOptionsState[0]; var setUsuariosOptions = usuariosOptionsState[1];
  var loadingUsuariosState = _useState(false);
  var loadingUsuarios = loadingUsuariosState[0]; var setLoadingUsuarios = loadingUsuariosState[1];
  var showExcluirModalState = _useState(null);
  var showExcluirModal = showExcluirModalState[0]; var setShowExcluirModal = showExcluirModalState[1];

  var caractGrupoState = _useState([]);
  var caractGrupo = caractGrupoState[0]; var setCaractGrupo = caractGrupoState[1];
  var loadingGrupoState = _useState(false);
  var loadingGrupo = loadingGrupoState[0]; var setLoadingGrupo = loadingGrupoState[1];
  var ordenacaoGrupoState = _useState({ campo: 'nome', direcao: 'asc' });
  var ordenacaoGrupo = ordenacaoGrupoState[0]; var setOrdenacaoGrupo = ordenacaoGrupoState[1];
  var ordenacaoUsuarioState = _useState({ campo: 'nome', direcao: 'asc' });
  var ordenacaoUsuario = ordenacaoUsuarioState[0]; var setOrdenacaoUsuario = ordenacaoUsuarioState[1];

  var temPermissao = AuthStorage.temCaracteristica(caracteristicas.ManutencaoUsuario);

  useEffect(function () {
    if (!isNovoMode && codigoUsuario) carregarPermissoes();
  }, [codigoUsuario]);

  useEffect(function () {
    if (codigoGrupo) carregarCaracteristicasGrupo();
  }, [codigoGrupo]);

  var carregarCaracteristicasGrupo = async function () {
    setLoadingGrupo(true);
    try {
      var res = await api.listarCaracteristicasGrupo(codigoGrupo);
      setCaractGrupo(res || []);
    } catch (e) { setCaractGrupo([]); }
    finally { setLoadingGrupo(false); }
  };

  var handleOrdenacao = function (setFn) {
    return function (campo) {
      setFn(function (prev) {
        if (prev.campo === campo) {
          return { campo: campo, direcao: prev.direcao === 'asc' ? 'desc' : 'asc' };
        }
        return { campo: campo, direcao: 'asc' };
      });
    };
  };

  var iconeOrdenacao = function (ordenacao, campo) {
    if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
    return ordenacao.direcao === 'asc'
      ? <FaSortUp style={{ marginLeft: 4 }} />
      : <FaSortDown style={{ marginLeft: 4 }} />;
  };

  var ordenarLista = function (lista, ordenacao) {
    return lista.slice().sort(function (a, b) {
      var dir = ordenacao.direcao === 'asc' ? 1 : -1;
      if (ordenacao.campo === 'codigo') {
        return dir * ((a.codigo || 0) - (b.codigo || 0));
      }
      if (ordenacao.campo === 'texto') {
        return dir * (a.texto || '').toLowerCase().localeCompare((b.texto || '').toLowerCase());
      }
      return dir * (a.nome || '').toLowerCase().localeCompare((b.nome || '').toLowerCase());
    });
  };

  var thSortStyle = { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' };

  var carregarPermissoes = async function () {
    setLoading(true);
    try {
      var res = await api.listarCaracteristicasUsuario(codigoUsuario);
      setPermissoes(res || []);
    } catch (e) { toast.error('Erro ao carregar permissões do usuário'); }
    finally { setLoading(false); }
  };

  var buscarCatalogo = async function () {
    setLoadingBusca(true);
    try {
      var res = await api.listarCaracteristicasCatalogo(termoBusca, filtroCaract);
      setCatalogo(res || []);
    } catch (e) { toast.error('Erro ao buscar catálogo'); }
    finally { setLoadingBusca(false); }
  };

  var carregarUsuariosOptions = async function () {
    setLoadingUsuarios(true);
    try {
      var resp = await api.buscarUsuarioOptions('todos');
      var ops = (resp || []).map(function (u) {
        var nome = u.nome_completo ? u.nome_completo : (u.apelido ? u.apelido : String(u.codigo_usuario));
        return { value: u.codigo_usuario, label: u.codigo_usuario + ' - ' + nome };
      });
      setUsuariosOptions(ops);
    } catch (e) { toast.error('Erro ao carregar usuários'); }
    finally { setLoadingUsuarios(false); }
  };

  var filtrarUsuarioCopiar = function (option, inputValue) {
    if (!inputValue) return true;
    var termo = inputValue.toLowerCase();
    return String(option.data.value).indexOf(termo) >= 0 || (option.data.label || '').toLowerCase().indexOf(termo) >= 0;
  };

  var handleAdicionarCaract = async function (codigoCaract) {
    setLoadingAcao(true);
    try {
      await api.incluirCaracteristicaUsuario(codigoUsuario, { codigo_caracteristica: codigoCaract });
      toast.success('Característica adicionada!');
      await carregarPermissoes();
      setShowAdicionarModal(false);
    } catch (e) {
      var msg = (e && e.message) ? e.message : 'Erro ao adicionar característica';
      toast.error(msg);
    }
    finally { setLoadingAcao(false); }
  };

  var handleRemoverCaract = async function (codigoCaract) {
    setLoadingAcao(true);
    try {
      await api.excluirCaracteristicaUsuario(codigoUsuario, codigoCaract);
      toast.success('Característica removida!');
      setShowExcluirModal(null);
      await carregarPermissoes();
    } catch (e) { toast.error('Erro ao remover característica'); }
    finally { setLoadingAcao(false); }
  };

  var handleCopiar = async function () {
    if (!usuarioFonte) { toast.warn('Selecione o usuário fonte'); return; }
    setLoadingAcao(true);
    try {
      var res = await api.copiarCaracteristicasUsuario(codigoUsuario, String(usuarioFonte.value));
      toast.success((res.qtd || '') + ' características copiadas!');
      setShowCopiarModal(false);
      setUsuarioFonte(null);
      await carregarPermissoes();
    } catch (e) { toast.error('Erro ao copiar características'); }
    finally { setLoadingAcao(false); }
  };

  if (isNovoMode) {
    return (
      <SectionCard title="Permissões" icon={<FaShieldAlt />}>
        <Alert variant="info" className="mb-0">Salve o usuário primeiro para gerenciar permissões.</Alert>
      </SectionCard>
    );
  }

  var actionButtons = temPermissao ? (
    <div className="d-flex" style={{ gap: 6 }}>
      <Button variant="outline-success" size="sm" onClick={function () { setTermoBusca(''); setCatalogo([]); setShowAdicionarModal(true); }}
        disabled={loadingAcao} style={{ fontSize: '0.8rem' }}>
        <FaPlus className="mr-1" size={10} /> Adicionar
      </Button>
      <Button variant="outline-secondary" size="sm" onClick={function () { setShowCopiarModal(true); }} disabled={loadingAcao}
        style={{ fontSize: '0.8rem' }}>
        <FaCopy className="mr-1" size={10} /> Copiar de Usuário
      </Button>
    </div>
  ) : null;

  var caractGrupoOrdenado = ordenarLista(caractGrupo, ordenacaoGrupo);
  var permissoesOrdenadas = ordenarLista(permissoes, ordenacaoUsuario);

  return (
    <>
      {/* ===== SEÇÃO: PERMISSÕES DO USUÁRIO ===== */}
      <SectionCard title="Características Diretas do Usuário" icon={<FaShieldAlt />} headerRight={actionButtons}>
        {loading ? (
          <p className="text-muted mb-0">Carregando...</p>
        ) : permissoesOrdenadas.length === 0 ? (
          <div className="text-center py-3" style={{ color: '#6c757d' }}>
            <FaShieldAlt size={24} className="mb-2 d-block mx-auto" style={{ opacity: 0.4 }} />
            <small>Nenhuma permissão direta vinculada.</small>
          </div>
        ) : (
          <>
            <div className="mb-2">
              <Badge variant="secondary" style={{ fontSize: '0.8rem' }}>{permissoesOrdenadas.length} permissão(ões)</Badge>
            </div>
            <div style={{ maxHeight: 300, overflowY: 'auto' }}>
              <Table striped bordered hover size="sm" className="mb-0">
                <thead style={{ position: 'sticky', top: 0, zIndex: 1, background: '#f8f9fa' }}>
                  <tr>
                    <th style={Object.assign({ width: 80 }, thSortStyle)} onClick={function () { handleOrdenacao(setOrdenacaoUsuario)('codigo'); }}>Código{iconeOrdenacao(ordenacaoUsuario, 'codigo')}</th>
                    <th style={Object.assign({ width: 220 }, thSortStyle)} onClick={function () { handleOrdenacao(setOrdenacaoUsuario)('nome'); }}>Nome{iconeOrdenacao(ordenacaoUsuario, 'nome')}</th>
                    <th style={Object.assign({}, thSortStyle)} onClick={function () { handleOrdenacao(setOrdenacaoUsuario)('texto'); }}>Descrição{iconeOrdenacao(ordenacaoUsuario, 'texto')}</th>
                    {temPermissao && <th style={{ width: 80, textAlign: 'center' }}>Ações</th>}
                  </tr>
                </thead>
                <tbody>
                  {permissoesOrdenadas.map(function (p) {
                    return (
                      <tr key={p.codigo}>
                        <td>{p.codigo}</td>
                        <td>{p.nome}</td>
                        <td>{p.texto || ''}</td>
                        {temPermissao && (
                          <td className="text-center">
                            <Button size="sm" variant="outline-danger" title="Remover"
                              onClick={function () { setShowExcluirModal({ codigo: p.codigo, nome: p.nome }); }}
                              disabled={loadingAcao}>
                              <FaTrash size={12} />
                            </Button>
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </>
        )}
      </SectionCard>

      {/* ===== SEÇÃO: GRUPO DO USUÁRIO ===== */}
      {codigoGrupo && (
        <SectionCard
          title={nomeGrupo ? 'Grupo: ' + codigoGrupo + ' - ' + nomeGrupo : 'Grupo: ' + codigoGrupo}
          icon={<FaUsers />}
        >
          {loadingGrupo ? (
            <p className="text-muted mb-0">Carregando...</p>
          ) : caractGrupoOrdenado.length === 0 ? (
            <div className="text-center py-3" style={{ color: '#6c757d' }}>
              <FaUsers size={24} className="mb-2 d-block mx-auto" style={{ opacity: 0.4 }} />
              <small>Nenhuma característica vinculada ao grupo.</small>
            </div>
          ) : (
            <>
              <div className="mb-2">
                <Badge variant="info" style={{ fontSize: '0.8rem' }}>{caractGrupoOrdenado.length} característica(s) do grupo</Badge>
              </div>
              <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                <Table striped bordered hover size="sm" className="mb-0">
                  <thead style={{ position: 'sticky', top: 0, zIndex: 1, background: '#f8f9fa' }}>
                    <tr>
                      <th style={Object.assign({ width: 80 }, thSortStyle)} onClick={function () { handleOrdenacao(setOrdenacaoGrupo)('codigo'); }}>Código{iconeOrdenacao(ordenacaoGrupo, 'codigo')}</th>
                      <th style={Object.assign({ width: 220 }, thSortStyle)} onClick={function () { handleOrdenacao(setOrdenacaoGrupo)('nome'); }}>Nome{iconeOrdenacao(ordenacaoGrupo, 'nome')}</th>
                      <th style={Object.assign({}, thSortStyle)} onClick={function () { handleOrdenacao(setOrdenacaoGrupo)('texto'); }}>Descrição{iconeOrdenacao(ordenacaoGrupo, 'texto')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {caractGrupoOrdenado.map(function (c) {
                      return (
                        <tr key={c.codigo}>
                          <td>{c.codigo}</td>
                          <td>{c.nome}</td>
                          <td>{c.texto || ''}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </>
          )}
        </SectionCard>
      )}

      {/* ===== MODAL: CONFIRMAR EXCLUSÃO ===== */}
      {showExcluirModal && (
        <Modal show={true} onHide={function () { setShowExcluirModal(null); }} centered>
          <Modal.Header closeButton>
            <Modal.Title><FaExclamationTriangle className="text-warning mr-2" />Confirmar Exclusão</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Deseja remover a característica <strong>{showExcluirModal.nome}</strong> (cód. {showExcluirModal.codigo}) deste usuário?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={function () { setShowExcluirModal(null); }}>Cancelar</Button>
            <Button variant="danger" onClick={function () { handleRemoverCaract(showExcluirModal.codigo); }} disabled={loadingAcao}>
              {loadingAcao ? 'Removendo...' : 'Remover'}
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* ===== MODAL: ADICIONAR CARACTERÍSTICA ===== */}
      {showAdicionarModal && (
        <Modal show={true} onHide={function () { setShowAdicionarModal(false); }} size="lg" centered>
          <Modal.Header closeButton><Modal.Title>Adicionar Característica</Modal.Title></Modal.Header>
          <Modal.Body>
            <Row className="mb-3">
              <Col md={6}>
                <InputGroup>
                  <div style={{ position: 'relative', flex: 1, display: 'flex' }}>
                    <Form.Control type="text" placeholder="Buscar..." value={termoBusca}
                      onChange={function (e) { setTermoBusca(e.target.value); }}
                      onKeyDown={function (e) { if (e.key === 'Enter') buscarCatalogo(); }}
                      style={{ paddingRight: '2rem', borderRadius: 0 }} />
                    {termoBusca && (
                      <span
                        onClick={function () { setTermoBusca(''); setCatalogo([]); }}
                        style={{ position: 'absolute', right: '0.5rem', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: '#6c757d', fontSize: '1.1rem', lineHeight: 1 }}
                        title="Limpar busca"
                      >&times;</span>
                    )}
                  </div>
                  <InputGroup.Append>
                    <Button variant="outline-primary" onClick={buscarCatalogo} disabled={loadingBusca}><FaSearch /></Button>
                  </InputGroup.Append>
                </InputGroup>
              </Col>
              <Col md={3}>
                <Form.Control as="select" value={filtroCaract} onChange={function (e) { setFiltroCaract(e.target.value); }}>
                  {opcoesFiltro.map(function (o) { return <option key={o.value} value={o.value}>{o.label}</option>; })}
                </Form.Control>
              </Col>
            </Row>
            {loadingBusca ? <p>Buscando...</p> : catalogo.length > 0 ? (
              <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                <Table striped bordered hover size="sm">
                  <thead><tr><th>Código</th><th>Nome</th><th>Descrição</th><th style={{ width: 80 }}>Ação</th></tr></thead>
                  <tbody>
                    {catalogo.map(function (c) {
                      return (
                        <tr key={c.codigo}>
                          <td>{c.codigo}</td>
                          <td>{c.nome}</td>
                          <td>{c.texto || ''}</td>
                          <td className="text-center">
                            <Button size="sm" variant="outline-success" onClick={function () { handleAdicionarCaract(c.codigo); }} disabled={loadingAcao}>
                              <FaPlus />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            ) : (
              <p className="text-muted text-center">Use a busca para encontrar características.</p>
            )}
          </Modal.Body>
          <Modal.Footer><Button variant="secondary" onClick={function () { setShowAdicionarModal(false); }}>Fechar</Button></Modal.Footer>
        </Modal>
      )}

      {/* ===== MODAL: COPIAR ===== */}
      {showCopiarModal && (
        <Modal show={true} onHide={function () { setShowCopiarModal(false); setUsuarioFonte(null); }} centered>
          <Modal.Header closeButton><Modal.Title>Copiar Permissões de Usuário</Modal.Title></Modal.Header>
          <Modal.Body>
            <Form.Group>
              <Form.Label>Usuário fonte</Form.Label>
              <Select
                styles={customStyles}
                options={usuariosOptions}
                value={usuarioFonte}
                onChange={setUsuarioFonte}
                filterOption={filtrarUsuarioCopiar}
                placeholder="Pesquise por código ou nome..."
                isClearable
                isLoading={loadingUsuarios}
                onMenuOpen={function () { if (usuariosOptions.length === 0) carregarUsuariosOptions(); }}
                loadingMessage={function () { return 'Carregando usuários...'; }}
                noOptionsMessage={function () { return 'Nenhum usuário encontrado'; }}
              />
            </Form.Group>
            <small className="text-muted">As permissões atuais serão substituídas pelas do usuário informado.</small>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={function () { setShowCopiarModal(false); setUsuarioFonte(null); }}>Cancelar</Button>
            <Button variant="primary" onClick={handleCopiar} disabled={loadingAcao} style={{ backgroundColor: '#7bb32e', borderColor: '#7bb32e' }}>
              {loadingAcao ? 'Copiando...' : 'Copiar'}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default TabPermissoes;
